import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { env } from '@/utils';

export const echo = new Echo({
    broadcaster: 'reverb',
    key: env().VITE_REVERB_APP_KEY,
    wsHost: env().VITE_REVERB_HOST,
    wsPort: env().VITE_REVERB_PORT,
    wssPort: env().VITE_REVERB_PORT,
    forceTLS: env().VITE_REVERB_SCHEME === 'https',
    enabledTransports: ['ws', 'wss'],
    Pusher: Pusher
});

// https://pusher.com/docs/channels/using_channels/connection/#available-states

export function onEchoEvent(event, fn) {
    if (![
        // All dependencies have been loaded and Channels is trying to connect. The connection will also enter this state when it is trying to reconnect after a connection failure.
        "connecting",
        // All dependencies have been loaded and Channels is trying to connect. The connection will also enter this state when it is trying to reconnect after a connection failure.
        "connected", 
        // The Channels connection was previously connected and has now intentionally been closed.
        "disconnected",
        // The connection is temporarily unavailable. In most cases this means that there is no internet connection. It could also mean that Channels is down, or some intermediary is blocking the connection. In this state, pusher-js will automatically retry the connection every 15 seconds.
        "unavailable",
        // Channels is not supported by the browser. This implies that WebSockets are not natively available and an HTTP-based transport could not be found.
        "failed",
        // emitted whenever a connection error occurs
        "error",
        // emitted whenever the connection state changes (callback takes a states{previous, current} object)
        "state_change"
    ].includes(event)) {
        console.warn(`Trying to bind to invalid Echo event '${event}'`)
        return
    }

    echo.connector.pusher.connection.bind(event, fn)
}

onEchoEvent("connecting", () => {
    console.log(`[echo] connecting`)
})

onEchoEvent("connected", (data) => {
    console.log(`[echo] connected ${JSON.stringify(data)}`)
})

onEchoEvent("disconnected", (data) => {
    console.warn(`[echo] disconnected ${JSON.stringify(data)}`)
})

onEchoEvent("unavailable", () => {
    console.error(`[echo] unavailable`)
})

onEchoEvent("failed", (data) => {
    console.error(`[echo] failed ${JSON.stringify(data)}`)
})